<template>
  
  <div id="app_content" class="public">

    <div class="content reset-password-form">

      <form v-if="!message" :class="{v_loading: loading}">

        <div class="back">
          <a :href="return_link">{{trans.get('auth.return_link')}}</a>
        </div>

        <h2 class="mt-0">{{trans.get('auth.reset.title')}}</h2>

        <div class='field username' v-if="user">

          <label for="">{{trans.get('auth.reset.username')}}</label>
          <input type="text" v-model="user.username" disabled>

        </div>

        <div class='field password'>

          <label for="">{{trans.get('auth.reset.password')}}</label>
          <v-password v-model="password" @blur="$v.$touch()"/>
          <span class="error" v-if="$v.$dirty && !$v.password.required">{{trans.get('validation.password_reset.password.required')}}</span>
          <span class="error" v-if="$v.$dirty && !$v.password.minLength">{{trans.get('validation.password_reset.password.length')}}</span>

        </div>

        <div class='field password-confirmation'>

          <label for="">{{trans.get('auth.reset.password_confirmation')}}</label>
          <v-password v-model="password_confirmation" @blur="$v.$touch()"/>
          <span class="error" v-if="$v.$dirty && !$v.password_confirmation.sameAs">{{trans.get('validation.password_reset.password_confirmation')}}</span>

        </div>

        <button class="belt-btn animated" 
          @click.prevent="sendRequest($event)"
          :disabled="$v.$invalid"
          :class="{v_loading: loading}">{{trans.get('auth.reset.request')}}</button>

      </form>

      <div v-else class="message">

        <div class="back">
          <a :href="return_link">{{trans.get('auth.return_link')}}</a>
        </div>

        <h3>{{message}}</h3>

      </div>

    </div>

  </div>

</template>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
export default{

  data: function(){

    return {
      return_link: window.location.origin,
      message: false,
      password: '',
      password_confirmation: '',
      loading: true,
      user: null,
      key: null
    }

  },

  validations: {

    password: {
      required,
      minLength: minLength(9)
    },
    password_confirmation: {
      sameAs: sameAs('password')
    }

  },

  methods: {

    verifyKey: function(){

      var vue = this;

      axios({
        method: "post",
        url: window.location.origin + '/data/check-recovery-token',
        data: {
          key: vue.key
        }
      })
      .then(res => {
        
        vue.user = res.data.user

      })
      .catch(err => {
        
        vue.message = err.response.data.message;

      })
      .then(() =>{
        vue.loading = false;
      })

    },

    sendRequest: function(event){

      var vue = this;
      event.target.classList.add('loading');

      axios({
        method: "post",
        url: window.location.origin + '/data/reset-password',
        data: {
          credential_id: vue.user.id,
          new_password: vue.password
        }
      })
      .then(res => {
        
        vue.message = res.data.message;

      })
      .catch(err => {

        console.log(err.response);

        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message
        })
        
      })
      .then(() => {
        event.target.classList.remove('loading');
      })

    }

  },

  beforeMount: function(){

    this.key = new URLSearchParams(window.location.search).get('key');

  },

  mounted: function(){

    this.verifyKey();

  }

}
</script>

<style scoped>
#app_content{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--black);
}
.content{
  width: 800px;
  max-width: 95%;
  height: auto;
  padding: 4em;
  border: 1px solid white;
  background-color: white;
}
.field{
  margin-bottom: 1em;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}
.field.username input{
  width: 100%;
  padding: 13px 20px;
}
.back{
  text-align: right;
}
.back a{
  color: var(--blue);
  text-decoration: underline;
}
.message h3{
  margin-top: 2em;
}
.v_loading::before{
  background-color: white;
}
span.error{
  font-size: .85em;
  color: var(--red);
}
</style>
